import { render } from "./DashboardPanel.vue?vue&type=template&id=5b673982&scoped=true"
import script from "./DashboardPanel.vue?vue&type=script&lang=js"
export * from "./DashboardPanel.vue?vue&type=script&lang=js"

import "./DashboardPanel.vue?vue&type=style&index=0&id=5b673982&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b673982"]])

export default __exports__